import { User, UserBlock, UsersColumnName, UsersList, UsersListFilterParams, UsersSortParams, UserTypes } from "@helper/types/user";
import { HttpErrorResponse } from "@angular/common/http";

export class GetUsers {
	public static readonly type = "[Users] Get Users";
	constructor(public sortParams?: UsersSortParams) { }
}

export class GetUsersSuccess {
	public static readonly type = "[Users] Get Users Success";

	constructor(public users: UsersList) { }
}

export class GetUsersError {
	public static readonly type = "[Users] Get Users Error";

	constructor(public error: HttpErrorResponse) { }
}

export class SetColumns {
	public static readonly type = "[Users] Set Columns";
	constructor(public columns: UsersColumnName[]) { }
}

export class GetUserTypes {
	public static readonly type = "[Users] Get User Types";
}

export class SetUserTypes {
	public static readonly type = "[Users] Set User Types";
	constructor(public userTypes: UserTypes) { }
}

export class EditUser {
	public static readonly type = "[Users] Edit User";
	constructor(public userData: User) { }
}

export class CreateUser {
	public static readonly type = "[Users] Create User";
	constructor(public userData: User) { }
}

export class Select {
	public static readonly type = "[Users] Select";
	constructor(public userIds: number[]) { }
}

export class DeleteUser {
	public static readonly type = "[Users] Delete User";
	constructor(public userId: number) { }
}

export class SetFilter {
	public static readonly type = "[Users] Set Filter";
	constructor(public filter: UsersListFilterParams) { }
}

export class ResetUserPassword {
	public static readonly type = "[Users] Reset User Password";
	constructor(public userId: number) { }
}

export class BlockUser {
	public static readonly type = "[Users] Reset Block User";
	constructor(public userData: User) { }
}

export class DeleteUsers {
	public static readonly type = "[Users] Delete Users";
	constructor(public userIds: number[]) { }
}

export class BlockUsers {
	public static readonly type = "[Users] Reset Block Users";
	constructor(public userData: UserBlock) { }
}

export class SetVisible {
	public static readonly type = "[Users] Set Visible";
	constructor(public userIds: number[]) { }
}
